export const checkIsDatePassed = (date) => {
  return new Date() >= new Date(date);
};

export const checkIsPassedTime = (date) => {
  const isPastTime = new Date().getTime() > date.getTime();
  return !isPastTime;
};
